export default __webpack_public_path__ + "static/media/unilag.de8d071e.png";